import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ width, theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: width || 400,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90vw',
    },
    overflowY: "auto",
    backgroundColor: "#f5f5f9",
    color: "rgb(107 114 128)",
    fontSize: "0.80rem",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
  },
}));

const CustomTooltip = ({ tooltipText, width, iconSize = 15 }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTooltipToggle = () => {
    setOpen(!open);
  };

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open && !event.target.closest('[data-tooltip-trigger]')) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('click', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [open]);

  return (
    <StyledTooltip
      title={tooltipText}
      width={width}
      placement="bottom-start"
      open={open}
      onClose={handleTooltipClose}
      onOpen={handleTooltipOpen}
      disableHoverListener={false}
      disableTouchListener={false}
      disableFocusListener={false}
      PopperProps={{
        disablePortal: false,
      }}
    >
      <InfoIcon
        data-tooltip-trigger 
        onClick={handleTooltipToggle} 
        onTouchStart={(e) => {
          e.preventDefault();
          handleTooltipToggle();
        }}
        sx={{
          fontSize: `${iconSize}px`,
          color: "rgba(0, 0, 0, 0.38)",
          cursor: "pointer",
          // minWidth: "24px",
          // minHeight: "24px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          verticalAlign: "middle", 
          WebkitTapHighlightColor: "transparent", 
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          userSelect: "none",
          touchAction: "manipulation",
        }}
      />
    </StyledTooltip>
  );
};

export default CustomTooltip;